export default __webpack_public_path__ + "static/resources-mega-small-9bb846c1b1d880c8e42948ba5c530326.png";